import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";
import { PaginationResponse } from "src/app/classes";
import { DoubletSuggestion } from "../../shared/classes";
import { IDoubletProviderService } from "../../shared/interfaces";
import { ContractService } from "./contract.service";

@Injectable()
export class CreateContractService implements IDoubletProviderService {

    private _checkerVisible = new BehaviorSubject<boolean>(true);
    checkerVisible$ = this._checkerVisible.asObservable();

    private _doubletClicked = new Subject<DoubletSuggestion>();
    doubletClicked$ = this._doubletClicked.asObservable();

    private _doublets = new ReplaySubject<PaginationResponse<DoubletSuggestion[]>>(1);
    doublets$ = this._doublets.asObservable();

    constructor(
        private _contractService: ContractService,
        private _router: Router
    ) { }

    doubletClick = (doublet: DoubletSuggestion) => {
        this._doubletClicked.next(doublet);
        this._router.navigate(['/contract-details', doublet.identifier]);
    }

    setSearchFilter(){
        throw new Error("not implemented");
    }

    setSearchString = (term: string) => this._contractService.searchContractsByString(term, { 'pageNumber': 1, 'pageSize': 50 }).subscribe((x => {
        var result = {
            totalItems: x.totalItems,
            content: x.content.map(y => {
                return {
                    title: [y.contractnumber, y.contractdesc].filter(z => z ? true : false).join(' '),
                    subTitles: [],
                    identifier: y.contractid
                } as DoubletSuggestion
            })
        } as PaginationResponse<DoubletSuggestion[]>;
        this._doublets.next(result);
    }));

    setDoubletCheckerVisible = (value: boolean) => this._checkerVisible.next(value);
}